import { render } from "./CargaArchivos.vue?vue&type=template&id=69fa1e53&scoped=true"
import script from "./CargaArchivos.vue?vue&type=script&lang=js"
export * from "./CargaArchivos.vue?vue&type=script&lang=js"

import "./CargaArchivos.vue?vue&type=style&index=0&id=69fa1e53&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fa1e53"]])

export default __exports__